import { Suspense, memo } from 'react';

import { Loading } from 'components/common/Loading/Loading';

export const SuspenseWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => <Suspense fallback={<Loading size={70} />}>{children}</Suspense>;

export const RouteSuspenseWrapper = memo(
  ({
    component: Component,
    ...props
  }: {
    component: React.ComponentType<any>;
  }) => (
    <Suspense fallback={<Loading size={70} />}>
      <Component {...props} />
    </Suspense>
  ),
);
